import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { OrganizationService } from '../../../../core/services/organization.service';

import { NotificationService } from '../../../../core/services/notification.service';
import { catchError, of } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { User } from '../../../../core/models/organization.interface';
import {
  BulkCreatePayload,
  MessageWithHeader,
} from '../../../../core/interfaces/notification.inerface';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertHelper } from '../../utils/alert-helper';
import { OrganizationUtilService } from '../../../../core/services/organization-util.service';
import { MessagingService } from '../../../../core/services/messaging.service';
@Component({
  selector: 'app-multiple-message',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './multiple-message.component.html',
  styleUrl: './multiple-message.component.css',
})
export class MultipleMessageComponent implements OnInit, OnDestroy {
  // Search
  @Input() users: User[] = [];
  @Input() options: any;
  orgTreeSearch = '';
  query = '';
  userInfo: any; // Added to fix the error
  maxFileSizeMB = 20; // Max size in MB
  isError: boolean = false;
  message: string | undefined;
  // Permissions

  public messageTemplates: any[] = [];
  filteredUsers: User[] = [];
  selectedFileName: string | null = null;
  organizations: any[] = [];
  selectedOrgId: any;
  selectedOrganization: any;
  constructor(
    public activeModal: NgbActiveModal,
    private notificationService: NotificationService,
    private organizationService: OrganizationService,
    private organizationUtilService: OrganizationUtilService,
    private mesasgingService: MessagingService,
  ) {}
  illumLive: boolean = true;
  sendSms: boolean = true;
  sendEmail: boolean = true;
  showErrorMessage: boolean = false;
  errorMessage: string = '';
  subject: string = '';
  illumLiveSmsBody: string = '';
  emailBody: string = '';
  selectedTemplateId: string = '';
  sendData = false;
  files: File[] = [];
  showUserSelect = false;
  userSearch = '';
  selectedUsers: any[] = [];
  data = {
    useApi: false,
    bulkOrg: false,
    options: {
      incidentId: '',
      perimeterId: '',
      statuses: [],
    },
    fromOrgId: '',
    fromUserId: '',
    toOrgId: '',
    toUserIds: [],
    title: '',
    body: '',
    bodyHtml: '',
  };
  showUserList = false;
  isLoading: boolean = false;
  ngOnDestroy(): void {
    
  }
  ngOnInit(): void {
    this.filteredUsers = this.users;
    this.getMessageTemplate();
   if (Array.isArray(this.userInfo)) {
  this.selectedUsers = this.userInfo.map((u: any) => ({
    id: u.id ?? u.userId,
    userId: u.userId ?? u.id,
    name: u.name,
  }));
} else if (this.userInfo && this.userInfo.name) {
  const uId = this.userInfo.id ?? this.userInfo.userId;
  this.selectedUsers = [{ id: uId, userId: uId, name: this.userInfo.name }];
}

    // if (Array.isArray(this.userInfo)) {
    //   this.allUsers = this.userInfo.map((u: any) => ({
    //     id: this.userInfo.id,
    //     name: this.userInfo.name
    //   }));
    // } else if (this.userInfo && typeof this.userInfo === 'object') {
    //   this.allUsers = [{
    //     id: this.userInfo.id,
    //     name: this.userInfo.name
    //   }];
    // }

    // Get filtered organizations (excluding IDs 1, 2, 7) as per the arclive papi project


    // this.organizations = this.organizationUtilService.getFilteredOrgs();
    // if (this.organizations.length > 0) {
    //   this.selectedOrgId = this.organizations[0].arcAngelId;
    // }

    if (this.organizationUtilService?.data?.myFirstOrg) {
      this.selectedOrganization = this.organizationUtilService.data.myFirstOrg;
      this.selectedOrgId = this.selectedOrganization.id;
    }

    if (this.options?.bulkOrg) {
      const orgName = this.options?.orgName || 'Organization';
      const recipientCount = this.options?.recipientCount || 0;
      this.options.recipients = `all ${orgName} users (total: ${recipientCount})`;
    }
    
  }

  ngOnChanges(): void {
    this.filteredUsers = this.users;
    if (this.userInfo && this.userInfo.name) {
      const uId = this.userInfo.id ?? this.userInfo.userId;
      this.selectedUsers = [{ id: uId, userId: uId, name: this.userInfo.name }];
    } else if (this.userInfo && Array.isArray(this.userInfo.users)) {
      this.selectedUsers = this.userInfo.users.map((u: any) => ({
        id: u.id ?? u.userId,
        userId: u.userId ?? u.id,
        name: u.name,
      }));
    }
     if (this.options?.bulkOrg) {
      const orgName = this.options?.orgName || 'Organization';
      const recipientCount = this.options?.recipientCount || 0;
      this.options.recipients = `all ${orgName} users (total: ${recipientCount})`;
    }
  }
  getMessageTemplate(): void {
    this.organizationService.getMessageTemplate().subscribe({
      next: (response: any) => {
        // Safely access rows; default to empty array if null or undefined
        const templates = response?.rows ?? [];
        // Assign templates or empty array to avoid undefined/null issues
        this.messageTemplates = templates;

      },
      error: (error) => {
        console.error('Failed to fetch message templates:', error);
      },
      complete: () => {
      },
    });
  }

  sendNew() {
    this.showErrorMessage = false;

    if (!this.sendData && !this.sendSms && !this.sendEmail) {
      this.showError('Please select a messaging method');
    } else if (!this.subject || this.subject.trim().length === 0) {
      this.showError('Please add a subject to the message.');
    } else if ((!this.illumLiveSmsBody || this.illumLiveSmsBody.trim().length === 0) && (this.sendData || this.sendSms)) {
      this.showError('Please add a body to the IllumLive/SMS message.');
    } else if (this.illumLiveSmsBody.length > 1500 && (this.sendData || this.sendSms)) {
      this.showError('IllumLive/SMS Message Character count exceeds 1500.');
    } else if ((!this.emailBody || this.emailBody.trim().length === 0) && this.sendEmail) {
      this.showError('Please add a body to the email message.');
    } else if (!this.selectedOrganization && !this.options?.useApi && !this.options?.bulkOrg) {
      this.showError('Please select an organization.');
    } else if (!this.options?.useApi && !this.options?.bulkOrg && this.selectedUsers.length === 0) {
      this.showError('There are no recipients.');
    } else {
      // all validations passed
      this.createNotificationNew();
    }
  }

  private showError(message: string) {
    this.errorMessage = message;
    this.showErrorMessage = true;

    setTimeout(() => {
      this.showErrorMessage = false;
      this.errorMessage = '';
    }, 4000); // hide error after 4s
  }

  createNotificationNew(): void {
    this.isLoading = true; // Start loader

    const methods: string[] = [];
    if (this.sendSms) methods.push('SMS');
    if (this.sendEmail) methods.push('EMAIL');
    if (this.sendData) methods.push('NOTIFICATION');
    const userId = localStorage.getItem('PAA_USER_ID');

    // --- Step 1: Send message to get messageId ---
    const payload: MessageWithHeader = {
      methods: methods,
      subject: this.subject,
      html: this.emailBody ? this.emailBody.replace(/\n/g, '<br>') : '',
      text: this.illumLiveSmsBody,
      entity: 'USER',
      userId: userId,
      toUserId: this.selectedUsers.map(u => this.getUserId(u)).filter(id => !!id)
    };

    this.notificationService.sendSMSandEMAIL(payload).subscribe({
      next: (res) => {
        if (!res || !res.id) {
          this.isLoading = false;
          return;
        }

        const messageId = res.id;

        // --- Step 2: If useApi, call bulkCreateToIncidentUsers ---
        if (this.options?.useApi) {
          const apiPayload = {
            messageId: messageId,
            incidentId: this.options.incidentId,
            statuses: this.options.statuses || ['UNKNOWN'],
            perimeterFilterType: this.options.perimeterFilterType || 'NONE',
            fromOrganizationId: this.options.fromOrgId
          };

          this.mesasgingService.bulkCreateToIncidentUsers(apiPayload).subscribe({
            next: (apiRes) => {
              // --- Step 3: Handle file attachment ---
              if (this.selectedFileName) {
                this.notificationService.createMessageAttachment(this.files[0], messageId)
                  .subscribe({
                    next: (attachRes) => {
                      if (attachRes) {
                        this.sendMessage(res); // Send final message
                      } else {
                        this.isLoading = false;
                        AlertHelper.error('Failed to attach file', 'Upload Failed');
                      }
                    },
                    error: (err) => {
                      this.isLoading = false;
                      console.error('Error in file attachment:', err);
                      AlertHelper.error('Failed to attach file', 'Upload Failed');
                    }
                  });
              } else {
                this.sendMessage(res); // No file to attach
                this.isLoading = false;
              }
            },
            error: (err) => {
              console.error('Error sending bulk API message:', err);
              this.isLoading = false;
            }
          });
        }else if(this.options?.bulkOrg){
            const apiPayload = {
            messageId: messageId,
            toUsersInOrganizationIds: [this.options.orgId],
            fromOrganizationId: this.options.orgId
          };

          this.mesasgingService.bulkCreateToOrganizationUsers(apiPayload).subscribe({
            next: (apiRes) => {
              // --- Step 3: Handle file attachment ---
              if (this.selectedFileName) {
                this.notificationService.createMessageAttachment(this.files[0], messageId)
                  .subscribe({
                    next: (attachRes) => {
                      if (attachRes) {
                        this.sendMessage(res); // Send final message
                      } else {
                        this.isLoading = false;
                        AlertHelper.error('Failed to attach file', 'Upload Failed');
                      }
                    },
                    error: (err) => {
                      this.isLoading = false;
                      console.error('Error in file attachment:', err);
                      AlertHelper.error('Failed to attach file', 'Upload Failed');
                    }
                  });
              } else {
                this.sendMessage(res); // No file to attach
                this.isLoading = false;
              }
            },
            error: (err) => {
              console.error('Error sending bulk API message:', err);
              this.isLoading = false;
            }
          });
        }else {
          // --- Normal bulk flow ---
          const bulkCreatePayload: BulkCreatePayload = {
            messageId: res.id,
            toUserIds: this.selectedUsers.map(user => this.getUserId(user)).filter(id => !!id),
            fromOrganizationId: this.organizationUtilService.data?.myFirstOrg?.id ?? 0
          };

          this.notificationService
            .bulkCreateToUsersAndOrganizations(bulkCreatePayload, messageId)
            .subscribe({
              next: (sendErr) => {
                if (this.selectedFileName) {
                  this.notificationService.createMessageAttachment(this.files[0], messageId)
                    .subscribe({
                      next: (attachRes) => {
                        if (attachRes) {
                          this.sendMessage(res);
                        } else {
                          this.isLoading = false;
                          AlertHelper.error('Failed to attach file', 'Upload Failed');
                        }
                      },
                      error: (error) => {
                        this.isLoading = false;
                        console.error('Error in file attachment:', error);
                        AlertHelper.error('Failed to attach file', 'Upload Failed');
                      }
                    });
                } else {
                  this.sendMessage(res);
                }
              },
              error: (sendErr) => {
                this.isLoading = false;
                console.error('Error sending message from organization:', sendErr);
              }
            });
        }
      },
      error: (err) => {
        console.error('Error sending message:', err);
        this.isLoading = false;
      }
    });
  }

  private sendMessage(res: any) {
    this.notificationService
      .sendMessageFromOrganization(res.id)
      .pipe(
        catchError((error) => {
          this.isLoading = false; // Stop loader on error
          if (error.status === 404) {
            AlertHelper.error(
              'Email could not be sent because the resource was not found (404).',
              'Send Failed'
            );
          } else {
            AlertHelper.error(
              'There was an error sending your message.',
              'Send Failed'
            );
          }
          console.error('Error sending message from organization:', error);
          return of(null);
        })
      )
      .subscribe((sendRes) => {
        this.isLoading = false; // Stop loader after final API call
        if (sendRes) {
          this.onClose();
          AlertHelper.success(
            'Your message was sent from the organization successfully.',
            'Message Sent!'
          );
        }
      });
  }

  closeWindow(): void {
  }
  private stripHtml(htmlStr: string): string {
    if (!htmlStr) return '';
    let formatted = htmlStr
      .replace(/<br\s*[\/]?>\r?\n?/gi, '\n')
      .replace(/<\/(p|div|h[1-6]|li|tr)>\r?\n?/gi, '\n')
      .replace(/<[^>]+>/g, '')
      .replace(/\n\s*\n+/g, '\n');
    try {
      const doc = new DOMParser().parseFromString(formatted, 'text/html');
      formatted = doc.body.textContent || formatted;
    } catch (e) {
      formatted = formatted
        .replace(/&nbsp;/g, ' ')
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'");
    }
    return formatted.trim();
  }

  onTemplateChange() {
    const templatesData = this.messageTemplates.find(
      (t: any) => t.id === this.selectedTemplateId
    );

    if (templatesData) {
      this.subject = templatesData.subject || '';
      const rawText = templatesData.text || '';
      const rawHtml = templatesData.html || '';

      this.illumLiveSmsBody = rawText ? this.stripHtml(rawText) : this.stripHtml(rawHtml);
      this.emailBody = rawHtml ? this.stripHtml(rawHtml) : this.stripHtml(rawText);
    }
  }

  private getUserId(user: any): string {
    if (!user) return '';
    const id = user.id ?? user.userId ?? user.toUserId;
    return id !== undefined && id !== null ? String(id) : '';
  }

  // Helper to check if user is selected
  isSelected(user: any): boolean {
    const targetId = this.getUserId(user);
    if (!targetId) return false;
    return this.selectedUsers.some(u => this.getUserId(u) === targetId);
  }

  toggleUser(user: any): void {
    const targetId = this.getUserId(user);
    if (!targetId) return;
    if (this.isSelected(user)) {
      this.selectedUsers = this.selectedUsers.filter(u => this.getUserId(u) !== targetId);
    } else {
      this.selectedUsers = [...this.selectedUsers, user];
    }
  }

  // Remove user from selected list
  removeUser(user: any): void {
    const targetId = this.getUserId(user);
    if (!targetId) return;
    this.selectedUsers = this.selectedUsers.filter(u => this.getUserId(u) !== targetId);
  }

  onSearchInput(term: string): void {
    this.applySearch(term);
  }

  applySearch(term: string): void {
    if (!term) {
      this.filteredUsers = this.users;
      return;
    }
    const searchTerm = term.toLowerCase();
    this.filteredUsers = this.users.filter(
      (user) =>
        user.name?.toLowerCase().includes(searchTerm) ||
        user.companyName?.toLowerCase().includes(searchTerm)
    );
  }
  triggerFileInput(): void {
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.click(); // Trigger file picker
    }
  }
  uploadFile(file: File): void {
  }
  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    if (!file) return;

    // Validate file type (image/* or video/*)
    if (!file.type.startsWith('image/') && !file.type.startsWith('video/')) {
      this.isError = true;
      this.message = 'Only image or video files are allowed!';
      this.selectedFileName = null;
      input.value = ''; // Reset input
      return;
    }

    // Validate size (max 20MB)
    const fileSizeMB = file.size / (1024 * 1024);
    if (fileSizeMB > this.maxFileSizeMB) {
      this.isError = true;
      this.message = `File size exceeds ${this.maxFileSizeMB}MB!`;
      this.selectedFileName = null;
      input.value = ''; // Reset input
      return;
    }
    this.isError = false;
    this.selectedFileName = file.name;
    this.files = input.files?.[0] ? Array.from(input.files) : [];
    this.message = `Selected file: ${file.name}`;
    // Optionally uploa
    // this.uploadFile(file);
  }
  onClose(): void {
    this.activeModal.dismiss('Cross click');
  }
}
